const STORAGE_KEY = 'cadstrom.pending-email-verification-subject';

/**
 * Remembers which account a blocked login belonged to. Kept out of the URL, which history and
 * analytics record.
 *
 * @param subject - The Auth0 subject the denial named.
 */
export function storePendingVerificationSubject(subject: string): void {
	try {
		window.sessionStorage.setItem(STORAGE_KEY, subject);
	} catch {
		// Storage can be blocked (private browsing); the screen then offers no re-send.
	}
}

/**
 * Reads the account a blocked login belonged to.
 *
 * @returns The stored Auth0 subject, or null if none was recorded or storage is unavailable.
 */
export function readPendingVerificationSubject(): string | null {
	try {
		return window.sessionStorage.getItem(STORAGE_KEY);
	} catch {
		return null;
	}
}
